var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 231,
    viewBox: "0 0 289 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.931 154.455H73.0278C68.5711 154.455 64.9583 150.842 64.9583 146.386C64.9583 141.929 68.5711 138.316 73.0278 138.316H28.0694C23.6128 138.316 20 134.703 20 130.247C20 125.79 23.6128 122.177 28.0694 122.177H74.1806C78.6372 122.177 82.25 118.565 82.25 114.108C82.25 109.651 78.6372 106.038 74.1806 106.038H45.3611C40.9045 106.038 37.2917 102.426 37.2917 97.969C37.2917 93.5124 40.9045 89.8996 45.3611 89.8996H91.4722C87.0156 89.8996 83.4028 86.2868 83.4028 81.8301C83.4028 77.3735 87.0156 73.7607 91.4722 73.7607H157.181C161.637 73.7607 165.25 77.3735 165.25 81.8301C165.25 86.2868 161.637 89.8996 157.181 89.8996H230.958C235.415 89.8996 239.028 93.5124 239.028 97.969C239.028 102.426 235.415 106.038 230.958 106.038H256.319C260.776 106.038 264.389 109.651 264.389 114.108C264.389 118.565 260.776 122.177 256.319 122.177H234.417C229.96 122.177 226.347 125.79 226.347 130.247C226.347 134.703 229.96 138.316 234.417 138.316H241.333C245.79 138.316 249.403 141.929 249.403 146.386C249.403 150.842 245.79 154.455 241.333 154.455H181.389C180.795 154.455 180.217 154.391 179.66 154.269C179.103 154.391 178.524 154.455 177.931 154.455Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260.931,
    cy: 146.557,
    r: 8.06944,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.965 53V59.9167",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.965 69.1389V76.0556",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.438 64.5278H194.354",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.576 64.5278H210.493",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.576 170.765V175.376",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.576 184.598V189.209",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.354 179.987H98.9651",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.188 179.987H112.799",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.667 151.313C187.27 149.35 188.711 147.297 189.99 145.172C192.803 140.498 194.83 135.476 196.069 130.299C197.322 125.064 197.768 119.669 197.406 114.313C197.089 109.639 196.157 104.996 194.606 100.514C193.067 96.0681 190.92 91.7811 188.162 87.7822C186.518 85.3993 184.658 83.1187 182.581 80.9676C179.53 77.8094 176.185 75.1095 172.63 72.8694C168.811 70.4625 164.75 68.5866 160.554 67.2435C155.3 65.5615 149.834 64.7155 144.368 64.7093C140.115 64.7045 135.862 65.2082 131.707 66.2223C127.029 67.3639 122.476 69.1524 118.19 71.5905C114.421 73.7337 110.858 76.3789 107.597 79.5279C103.499 83.4851 100.179 87.946 97.641 92.7201C95.156 97.3942 93.4203 102.368 92.4365 107.464C91.423 112.714 91.2077 118.093 91.7937 123.406C92.5532 130.292 94.6588 137.066 98.1172 143.304C100.33 147.295 103.097 151.067 106.419 154.507C111.694 159.968 117.852 164.059 124.447 166.771C132.467 170.069 141.135 171.329 149.647 170.534C156.791 169.867 163.826 167.753 170.277 164.183",
    fill: "#2C2C2C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.667 151.313C187.27 149.35 188.711 147.297 189.99 145.172C192.803 140.498 194.83 135.476 196.069 130.299C197.322 125.064 197.768 119.669 197.406 114.313C197.089 109.639 196.157 104.996 194.606 100.514C193.067 96.0681 190.92 91.7811 188.162 87.7822C186.518 85.3993 184.658 83.1187 182.581 80.9676C179.53 77.8094 176.185 75.1095 172.63 72.8694C168.811 70.4625 164.75 68.5866 160.554 67.2435C155.3 65.5615 149.834 64.7155 144.368 64.7093C140.115 64.7045 135.862 65.2082 131.707 66.2223C127.029 67.3639 122.476 69.1524 118.19 71.5905C114.421 73.7337 110.858 76.3789 107.597 79.5279C103.499 83.4851 100.179 87.946 97.641 92.7201C95.156 97.3942 93.4203 102.368 92.4365 107.464C91.423 112.714 91.2077 118.093 91.7937 123.406C92.5532 130.292 94.6588 137.066 98.1172 143.304C100.33 147.295 103.097 151.067 106.419 154.507C111.694 159.968 117.852 164.059 124.447 166.771C132.467 170.069 141.135 171.329 149.647 170.534C156.791 169.867 163.826 167.753 170.277 164.183",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.128 161.979C177.478 159.823 180.457 157.133 182.394 154.962L174.128 161.979Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.128 161.979C177.478 159.823 180.457 157.133 182.394 154.962",
    stroke: "#D0AB56",
    strokeWidth: 2.88194,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.917 120.754C192.587 120.76 192.257 120.763 191.925 120.763C162.814 120.763 138.977 98.0663 136.979 69.3204C113.808 72.9754 96.0835 93.1282 96.0835 117.441C96.0835 144.344 117.785 166.154 144.555 166.154C170.218 166.154 191.222 146.112 192.917 120.754Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.791 116.833C124.381 115.53 122.193 115.63 120.905 117.056C119.617 118.482 119.716 120.693 121.126 121.995L137.402 137.025C139.376 138.848 142.439 138.708 144.242 136.712C144.318 136.627 144.318 136.627 144.39 136.54L167.617 108.301C168.839 106.816 168.638 104.612 167.169 103.377C165.701 102.143 163.52 102.346 162.299 103.83L140.462 130.38L125.791 116.833Z",
    fill: "url(#paint0_linear_160_835)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.158 74.4077C125.91 75.2511 123.714 76.276 121.593 77.4827C118.296 79.3579 115.179 81.6723 112.326 84.4274C111.156 85.5568 110.059 86.7331 109.035 87.9505M105.865 92.1889C105.05 93.4199 104.301 94.6819 103.616 95.9698C103.11 96.9211 102.64 97.8866 102.205 98.8643",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.664 75.7569C129.409 75.4773 129.787 74.6467 129.507 73.9016C129.228 73.1565 128.397 72.779 127.652 73.0586L128.664 75.7569ZM121.593 77.4827L122.305 78.7352L121.593 77.4827ZM112.326 84.4274L111.325 83.3909L112.326 84.4274ZM107.932 87.0227C107.42 87.6316 107.498 88.5406 108.107 89.053C108.716 89.5654 109.625 89.4872 110.137 88.8783L107.932 87.0227ZM107.067 92.9842C107.506 92.3205 107.324 91.4265 106.66 90.9873C105.996 90.5481 105.102 90.7301 104.663 91.3937L107.067 92.9842ZM103.616 95.9698L104.888 96.6462L103.616 95.9698ZM100.889 98.2788C100.565 99.006 100.893 99.8576 101.62 100.181C102.347 100.504 103.199 100.177 103.522 99.4497L100.889 98.2788ZM127.652 73.0586C125.333 73.9284 123.068 74.9855 120.88 76.2302L122.305 78.7352C124.36 77.5665 126.487 76.5738 128.664 75.7569L127.652 73.0586ZM120.88 76.2302C117.479 78.1645 114.266 80.5512 111.325 83.3909L113.327 85.464C116.092 82.7933 119.112 80.5513 122.305 78.7352L120.88 76.2302ZM111.325 83.3909C110.12 84.5548 108.989 85.7674 107.932 87.0227L110.137 88.8783C111.13 87.6988 112.193 86.5588 113.327 85.464L111.325 83.3909ZM104.663 91.3937C103.823 92.6634 103.05 93.965 102.344 95.2935L104.888 96.6462C105.551 95.3987 106.278 94.1765 107.067 92.9842L104.663 91.3937ZM102.344 95.2935C101.822 96.2746 101.337 97.2704 100.889 98.2788L103.522 99.4497C103.943 98.5027 104.399 97.5675 104.888 96.6462L102.344 95.2935Z",
    fill: "#D0AB56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_835",
    x1: 144.208,
    y1: 102.569,
    x2: 144.208,
    y2: 138.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8852B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0AB56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.487a6fc4618b39bb6557b9c682e6f909.svg";
export { ForwardRef as ReactComponent };